module.exports = __webpack_public_path__ + "assets/plugins.cc25a56d.svg";